// created by AI

import { CDN_URL, LOGOS_PATH, VESSELS_PATH } from "@utils/cdn"

// created by AI: Keep the extension order explicit so the browser retry components
// probe the CDN in the same order every time.
const COMPANY_LOGO_EXTENSIONS = ["png", "svg", "jpg"] as const
const VESSEL_IMAGE_EXTENSIONS = ["jpg", "png"] as const

// created by AI: These paths are the existing company-specific vessel fallback images.
// The values stay relative to /vessels because the CDN keeps placeholders there.
const COMPANY_VESSEL_PLACEHOLDER_PATHS: Readonly<Record<string, string>> = {
	"color line marine": "/color line marine/placeHolderImage.png",
	Unspecified: "/placeHolderImage.png",
}

// created by AI: Normalize only company path names to lowercase so CDN folders and
// logo files do not depend on the capitalization used by backend/customer data.
const getCdnCompanyName = (companyName: string): string => {
	return companyName.toLowerCase()
}

// created by AI: Build logo candidates from the lowercase company name, keeping
// spaces and punctuation so adding a CDN file does not require a frontend redeploy.
export const getCompanyLogoCandidateUrls = (companyName: string): string[] => {
	const cdnCompanyName = getCdnCompanyName(companyName)

	return COMPANY_LOGO_EXTENSIONS.map(
		(extension) => `${CDN_URL}/${LOGOS_PATH}/${cdnCompanyName}.${extension}`
	)
}

// created by AI: Build vessel candidates directly from exact vessel names because
// the same vessel can appear under multiple client pages.
export const getVesselImageCandidateUrls = (vesselName: string): string[] => {
	return VESSEL_IMAGE_EXTENSIONS.map(
		(extension) => `${CDN_URL}/${VESSELS_PATH}/${vesselName}.${extension}`
	)
}

// created by AI: Resolve the company-specific placeholder image while preserving the
// repository's current fallback behavior for companies without a dedicated placeholder.
export const getVesselPlaceholderImageUrl = (companyName = "Unspecified"): string => {
	const cdnCompanyName = getCdnCompanyName(companyName)

	return `${CDN_URL}/${VESSELS_PATH}${
		COMPANY_VESSEL_PLACEHOLDER_PATHS[cdnCompanyName] ??
		COMPANY_VESSEL_PLACEHOLDER_PATHS.Unspecified
	}`
}
